export default __webpack_public_path__ + "static/james-bitmoji-df543b43a76b979c826da0ac1adbfca7.png";